import {
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { HiOutlineDotsCircleHorizontal } from 'react-icons/hi';
import CustomModal from '../../../components/CustomModal';
import ShareInviteLink from '../../invite-guest/components/ShareInviteLink';

export const Options = ({ path, inviteCode }) => {
  return (
    <Menu>
      <MenuButton as={Box} cursor='pointer'>
        <HiOutlineDotsCircleHorizontal size={25} />
      </MenuButton>
      <MenuList>
        {/* <MenuItem>
          <Link to={path}>Invite more guest</Link>
        </MenuItem> */}

        <MenuItem>
          <CustomModal
            div
            buttonProps={{ color: 'primary' }}
            btnTitle={'Share code'}
          >
            <ShareInviteLink guestCode={inviteCode} />
          </CustomModal>
        </MenuItem>

        <MenuItem>
          <CustomModal
            div
            buttonProps={{ color: 'primary' }}
            btnTitle={'View code'}
          >
            <Text fontSize='1.2rem' fontWeight='600'>
              Code for event: {inviteCode}
            </Text>
          </CustomModal>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
